import { topics } from '@/mocks/home';

export default function TopicsSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">全网最热黑料吃瓜话题实时追踪</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <button
              key={topic.id}
              onClick={() => handleScroll('#ranking')}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-secondary-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              {topic.badge && (
                <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full ${topic.badgeColor} text-background-50 text-[10px] font-bold leading-none`}>
                  {topic.badge}
                </span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.heat}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}